import { createAuthClient } from "better-auth/react";
import { 
    twoFactorClient, 
    magicLinkClient, 
    adminClient, 
    multiSessionClient, 
    organizationClient,
} from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.replace(/\/$/, "");
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const authClient = createAuthClient({
    baseURL: `${supabaseUrl}/functions/v1/auth`,
    fetchOptions: {
        headers: {
            Authorization: `Bearer ${supabaseAnonKey}`
        }
    },
    plugins: [
        twoFactorClient({
            issuer: "AdvisorMuse",
        }),
        passkeyClient(),
        magicLinkClient(),
        adminClient(),
        multiSessionClient(),
        organizationClient(),
    ]
});
